/* eslint-disable no-underscore-dangle */
/* eslint-disable max-len */
import axios from 'axios';
// import loginwall from '@/service/loginwall';
import { isAPP, isBoxAPP } from '@/service/ua';

import config from './config';
import { monitor } from './monitor';
import * as localStorageKey from './const/localStorageKey';
// eslint-disable-next-line import/no-cycle
import GtFeedback from './gtFeedback';
import { UniqueLogout, UniqueUserState } from '@/service/boxNativeApi';

const string2object = data => (typeof data === 'string' && data.startsWith('{') ? JSON.parse(data) : data);

function isNeedStringify(data) {
  return Object.prototype.toString.call(data) !== '[object String]';
}

const service = axios.create({
  timeout: config.reqTimeout,
  transformResponse: [string2object],
});
// 极验防刷
const gtInsurance = new GtFeedback(service);

const setToken = () => {
  const token = window.localStorage.getItem(localStorageKey.token);
  if (token) {
    service.defaults.headers.common.token = token;
  }

  service.defaults.headers.common['black-token'] = window.localStorage.getItem(localStorageKey.blackToken)
    || window.localStorage.getItem(localStorageKey.blackToken2);
};

setToken();

// if (config.env !== 'prod') {
// 非正式环境允许模拟
// 模拟 线上 JAVA TOKEN
// service.defaults.headers.common.token = 'eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiIxMjA0Mzk3MzI0MTU2MTQ1Njc5IiwiYm9keSI6IntcImlkZW50aWZpZXJcIjpcIjI4NTM4Nzg1N1wiLFwibmlja25hbWVcIjpcIuaxn-S6rlwiLFwic2V4XCI6MCxcInVzZXJJZFwiOjEyMDQzOTczMjQxNTYxNDU2Nzl9IiwicmFuIjotMTMwNTE1MzQwfQ.1IQoVq9DB655CoLYr3-E9CaQb2uf9Gf9BD-4b4Kr4DOofrx7rk-WAaIDkY_MUXX6dAhZATVaqQSI78jkI9_szQ';
// service.defaults.headers.common.token = 'eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiIxMjMyNDk2ODM2NzM3MTEwMDIwIiwiYm9keSI6IntcImlkZW50aWZpZXJcIjpcIjI1MDY2OTU1N1wiLFwibmlja25hbWVcIjpcInh1eXVcIixcInNleFwiOjAsXCJ1c2VySWRcIjoxMjMyNDk2ODM2NzM3MTEwMDIwfSIsInJhbiI6LTQ5OTYwMzAxMX0._dQtX_9OjxisGgPGT8ITVbW7FGuSvOxuzmitG60e98ok5zRwU0IoYfMJq8abUj9WDF5QaBms_F17YCUcQqbm-Q';
// service.defaults.headers.common.token = 'eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiIxMTk5MjgwMTM1NDg5MDY4NjU0IiwiYm9keSI6IntcImlkZW50aWZpZXJcIjpcIjI0ODc0OTgxOFwiLFwibmlja25hbWVcIjpcIuiLj-eBv-amlVwiLFwic2V4XCI6MCxcInVzZXJJZFwiOjExOTkyODAxMzU0ODkwNjg2NTR9IiwicmFuIjoxOTA3ODI4MTR9.Qmm9alnPMB_qeb6o38MmFx5ecCgspqRlWaIgGungpOorEPpLHI55xoxxRyjImQu08NjY4Q4tYi6qD0ocUPoKfA';
// 模拟 test JAVA TOKEN
// service.defaults.headers.common.token = 'eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiIxMjA0Mzk3MzI0MTU2MTQ1Njc5IiwiYm9keSI6IntcImlkZW50aWZpZXJcIjpcIjI4NTM4Nzg1N1wiLFwibmlja25hbWVcIjpcIuaxn-S6rlwiLFwic2V4XCI6MCxcInVzZXJJZFwiOjEyMDQzOTczMjQxNTYxNDU2Nzl9IiwicmFuIjotMTMwNTE1MzQwfQ.1IQoVq9DB655CoLYr3-E9CaQb2uf9Gf9BD-4b4Kr4DOofrx7rk-WAaIDkY_MUXX6dAhZATVaqQSI78jkI9_szQ';
// }

// 请求拦截器
let checkLogin = false;
service.interceptors.request.use(
  async conf => {
    const bboxtoken = window.localStorage.getItem(localStorageKey.BlindToken);
    const token = window.localStorage.getItem(localStorageKey.token);
    const blackToken = window.localStorage.getItem(localStorageKey.blackToken)
    || window.localStorage.getItem(localStorageKey.blackToken2);
    if (bboxtoken) {
      conf.headers['bbox-token'] = bboxtoken;
    }
    if (token) {
      conf.headers.token = token;
    }
    if (blackToken) {
      conf.headers['black-token'] = blackToken;
    }
    
    let appUserInfo;
    // 获取原生用户信息
    if (isBoxAPP && !bboxtoken) {
      appUserInfo = await UniqueUserState();
      appUserInfo = JSON.parse(appUserInfo);
      if (appUserInfo.code === '0') {
        const {
          authToken, userId, cardToken, shopToken,
        } = appUserInfo.data;
        window.localStorage.setItem(localStorageKey.BlindToken, authToken);
        window.localStorage.setItem(localStorageKey.BlindUserId, userId);
        window.localStorage.setItem(localStorageKey.blackToken, cardToken);
        window.localStorage.setItem(localStorageKey.blackToken2, cardToken);
        window.localStorage.setItem(localStorageKey.token, shopToken);
        conf.headers['bbox-token'] = authToken;
        conf.headers.token = shopToken;
        conf.headers['black-token'] = authToken;
      }
    }
    if (conf.method === 'post' && isAPP) {
      conf.headers['request-body'] = encodeURIComponent(
        JSON.stringify(conf.data),
      );
    }
    if (checkLogin) return conf;

    // 白名单
    const projectName = (/\/([^/]+?)\.html/.exec(location.pathname) || [])[1];
    const pageName = (/\/([^/]+?)\b/.exec(location.hash) || [])[1];
    const whiteListPage = config.loginwallWhiteList.find(item => {
      const arr = item.split('/');
      if (arr.length === 2) {
        return projectName === arr[0] && arr[1].indexOf(pageName) !== -1;
      }
      return arr[0].indexOf(projectName) !== -1;
    });

    if (whiteListPage) {
      checkLogin = true;
      return conf;
    }

    // const needJumpLoginPage = config.jumpLoginPageList.some(project => project === projectName);
    // 登录墙
    // const ret = await loginwall(needJumpLoginPage);
    checkLogin = true;
    // if (ret === 'setToken') {
    //   conf.headers.token = window.localStorage.getItem(localStorageKey.token);
    //   conf.headers['black-token'] = window.localStorage.getItem(localStorageKey.blackToken);
    //   setToken();
    // }
    return conf;
  },
  error => {
    monitor.report({
      level: 'error',
      error: 'api',
      msg: 'request 异常！',
    });
    return Promise.resolve(error);
  },
);

// 响应拦截器
// TODO 异常上报
service.interceptors.response.use(
  async response => {
    const {
      data: { code, msg, Code },
      config: { url, headers, data: reqBody },
    } = response;
    const isGt = code === 524 || code === 523;
    if (code !== 200 && code !== 0 && Code !== 0 && !isGt) {
      const token = headers.token || headers['black-token'] || 'token缺失';
      monitor.report({
        level: 'error',
        error: 'api',
        url,
        token,
        identify: localStorage.getItem('member_id') || '',
        service_id: localStorage.getItem('guid') || 0,
        data: isNeedStringify(reqBody) ? JSON.stringify(reqBody) : reqBody,
        msg: `后端接口内部异常抛出>>> ${code} : ${msg}`,
      });
    }
    // token过期
    if (code === 503) {
      if (!isBoxAPP) {
        window.location.href = `${location.origin}/promo/public-blind/blindBox.html?refer=${encodeURIComponent(window.location.href)}#login`;
      } else {
        // 处理盲盒app内token过期情况
        console.log('BlindToken', window.localStorage.getItem('BlindToken'));
        // 原生退出登录
        UniqueLogout({
          type: 0, // 0: 退出登录， 1: 注销账户
        });
      }
    }
    // const res = await gtFeedbackIns.verifyAjax();
    return response;
  },
  error => {
    // eslint-disable-next-line no-console
    console.log(error);
    const {
      code,
      message,
      config: { url },
    } = error.toJSON();
    monitor.report({
      level: 'error',
      error: 'api',
      url,
      identify: localStorage.getItem('member_id') || '',
      service_id: localStorage.getItem('guid') || 0,
      msg: `${code}: ${message}`,
    });
    return Promise.resolve({
      data: {
        msg: '您的网络开小差啦！重新试一试吧',
      },
    });
  },
);
// for rewrite get
const _get = service.get;
// for rewrite post
const _post = service.post;

service.post = (...args) => new Promise(async resolve => {
  const result = await _post(...args); // ues old method to request
  // process result
  const { data } = result;
  const { code } = data || {};
  // 高风险进入极验
  if (code === 524 || code === 523) {
    gtInsurance
      .vertifyGt()
      .then(async unique => {
        // rewrite and merge headers
        if (!args[2]) {
          args[2] = {
            headers: { 'risk-uuid': unique },
          };
        } else {
          args[2].headers = {
            ...args[2].headers,
            'risk-uuid': unique,
          };
        }
        resolve(await service.post(...args));
      })
      .catch(() => {
        resolve(result);
      });
  } else {
    resolve(result);
  }
});

service.get = (...args) => new Promise(async resolve => {
  // console.log("is in new get method"); // test print
  const result = await _get(...args); // ues old method to request

  // process result
  const { data } = result;
  const { code } = data || {};
  // 高风险进入极验
  if (code === 524 || code === 523) {
    gtInsurance
      .vertifyGt()
      .then(async unique => {
        // rewrite and merge headers
        if (!args[1]) {
          args[1] = {
            headers: { 'risk-uuid': unique },
          };
        } else {
          args[1].headers = {
            ...args[1].headers,
            'risk-uuid': unique,
          };
        }
        //  resolve2 => resolve1
        resolve(await service.get(...args));
      })
      .catch(() => {
        resolve(result);
      });
  } else {
    resolve(result);
  }
});

export default service;
